// Shim for nanoid/non-secure that guarantees CJS exports for postcss in styled-components v6.
// postcss does `let { nanoid } = require('nanoid/non-secure')` which breaks when webpack
// resolves to the ESM version due to nanoid's package.json exports field.
const urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

const nanoid = (size = 21) => {
    let id = '';
    let i = size | 0;
    while (i--) {
        id += urlAlphabet[(Math.random() * 64) | 0];
    }
    return id;
};

module.exports = { nanoid };
